import React, { useMemo, useState } from 'react';
import { BackButton, PageTitle } from '../ui';
import { RadioGroup } from '../ui/Radio';
import DriverInfoCard from './driverInfoCard';
import { getSearchResult } from '../../utils/validations';
import Loader from '../elements/loader';
import { useDriversListForCar } from '../../hooks/react-query/useDrivers';

const AssignDriverView = ({ carData, handleBackClick, handleDriverSelect }) => {
  const { plateno } = carData;
  const { data: driverData, isLoading } = useDriversListForCar(plateno);
  const [searchTerm, setSearch] = useState('');

  const subTitle = (
    <>
      Επίλεξε οδηγό για το <b>{carData?.ModelName}</b>.
    </>
  );
  const handleSearch = (value) => {
    setSearch(value);
  };

  let { data: driverList } = driverData || {};

  driverList = useMemo(() => {
    return searchTerm ? getSearchResult(driverList, searchTerm) : driverList;
  }, [searchTerm, driverList]);

  return (
    <>
      {isLoading && <Loader className="fill-primary" />}
      <div className="flex flex-col lg:gap-6 gap:4 lg:pb-6 pb-3">
        <BackButton
          text="Επιστροφή My Cars"
          handleBackClick={handleBackClick}
        />
        <PageTitle
          title={<h2>Προσθήκη Οδηγού</h2>}
          subTitle={subTitle}
          wrapperClassName="justify-between"
          className="flex-[3_3_0%]"
          searchClassName="lg:flex-1 lg:self-end"
          handleSearch={handleSearch}
          placeholder="Αναζήτηση (μέσω email)"
        />
      </div>
      <RadioGroup
        className="grid md:grid-cols-2 xl:grid-cols-3 gap-3 pb-10"
        onValueChange={handleDriverSelect}
      >
        {driverList?.map((driverData) => {
          return (
            <DriverInfoCard
              driverData={driverData}
              key={driverData.id}
              wrapperClass="lg:w-full"
            />
          );
        })}
      </RadioGroup>
    </>
  );
};

export default AssignDriverView;
